import { Injectable } from '@angular/core';

import { RegistrationStatus } from '../../enum/registration-status.enum';
import { IReRegistrationMessage } from '../../interfaces/re-registration/re-resgistration.interface';

export const REREGISTRATION_MESSAGES: Record<number, IReRegistrationMessage> = {
    [RegistrationStatus.UserExpired]: {
        icon: 'modal-icon--danger',
        title: 'Para desbloquear a sua conta, atualize seus dados cadastrais.',
        description: `Sua conta foi temporariamente bloqueada para novos investimentos.
            A atualização periódica do cadastro é exigida por lei para todos os investidores.`,
        routeReRegister: '/minha-conta/atualizacao-cadastral/',
    },
    [RegistrationStatus.UserPreExpired]: {
        icon: 'modal-icon--warning',
        title: 'Atualize seus dados cadastrais para continuar a investir.',
        description: `Por lei, todos os investidores precisam atualizar os dados
        cadastrais periodicamente. Clique no botão abaixo para conferir suas informações
        de cadastro e desbloquear a sua conta.`,
        routeReRegister: '/minha-conta/atualizacao-cadastral/',
    },
};

@Injectable({
    providedIn: 'root',
})
export class UserReRegistationService {

    /**
     * Retorna um obeto de configuração de mensagem/dialog por registrationstatus
     */
    public getReRegistrationMessage(status: RegistrationStatus) {
        return REREGISTRATION_MESSAGES[status] || null;
    }

    /**
     * FIXME: Mantido por razão de compatibilidade, usar constante diretamente ou getReRegistrationMessage
     *
     * RegistrationStatus.UserExpired
     * Expired = 15
     */
    public validateUserExpired(registrationStatus: number) {
        return this.getReRegistrationMessage(registrationStatus);
    }

    /**
     * FIXME: Mantido por razão de compatibilidade, usar constante diretamente ou getReRegistrationMessage
     *
     * RegistrationStatus.UserPreExpired
     * PreExpired = 18
     */
    public validateUserPreExpired(registrationStatus: number) {
        return this.getReRegistrationMessage(registrationStatus);
    }

}
